<div class="tab-pane" role="tabpanel" id="recepcion_parcial">
    <fieldset id="agregar_recepcion_parcial" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Recepcion Parcial</strong></h3>
            <hr>
            <form [formGroup]="form">
                <div class="row" id="row">
                    <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                        <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                        <span id="tp_dir_message"></span>
                    </div>
                    <div class="form-group" align="left">
                        <div class="col-md-12">
                            <div class="col-md-4">
                                <label for="dproy" style="padding-top: 15px; padding-bottom: 15px">Superficie Edificada que se recepciona</label>
                            </div>
                            <div class="col-md-3">
                                <mat-form-field class="example-full-width" style="width: 145px;">
                                    <input matInput placeholder="Superficie" id="superedif" name="superedif" formControlName="superedif" (change)="add_recepcion()">
                                    <span matSuffix>m²</span>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12" style="padding-top: 10px"></div>
                    <div class="col-md-12">
                        <div class="col-md-4">
                            <label class=" control-label" for="cambios">Ha habido cambios en el Proyecto Aprobado (art. 5.2.8.OGUC)</label>
                        </div>
                        <div class="col-md-4">

                            <div class="inline">
                                <mat-radio-group formControlName="cambios" (change)="add_recepcion()">
                                    <mat-radio-button style="padding-right: 20px" name="cambios" value="SI">SI</mat-radio-button>
                                    <mat-radio-button style="padding-right: 20px" name="cambios" value="NO">NO</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </fieldset>
</div>
<div class="separator"></div>